import script from "./deleteVideoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./deleteVideoModal.vue?vue&type=script&setup=true&lang=js"

import "./deleteVideoModal.vue?vue&type=style&index=0&id=a9383098&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9383098"]])

export default __exports__